import React from "react";
import { useTranslation } from "react-i18next";

function TicketSaleCTA() {
  const { t } = useTranslation();

  return (
    <section className="pt-12 pb-12 bg-primary dark:bg-primary-light transition-colors relative z-10" id="ticket-sale">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-white relative inline-block">
            {t("ticketSale.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-white rounded-sm" />
          </h2>
          <p className="text-white/90 dark:text-white/90 text-lg leading-relaxed mb-8">
            {t("ticketSale.description")}
          </p>
          <a
            href="https://arena-bernau.de/de"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-primary dark:text-primary-light text-lg font-semibold rounded-full border-2 border-white transition-all duration-300 hover:bg-primary dark:hover:bg-primary-light hover:text-white hover:-translate-y-1 hover:shadow-lg"
          >
            <i className="fas fa-ticket-alt"></i>
            {t("ticketSale.button")}
          </a>
        </div>
      </div>
    </section>
  );
}

export default TicketSaleCTA;
